import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import authService from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      try {
        const userData = await authService.getCurrentUser();
        setUser(userData);
      } catch (error) {
        // User not authenticated
      } finally {
        setLoading(false);
      }
    };
    initAuth();
  }, []);

  const login = useCallback(async (email, password) => {
    const response = await authService.login(email, password);
    setUser(response.user);
    return response;
  }, []);

  const refreshUser = useCallback(async () => {
    const userData = await authService.getCurrentUser();
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(async () => {
    await authService.logout();
    setUser(null);
  }, []);

  const value = {
    user,
    login,
    logout,
    refreshUser,
    updateUser: setUser,
    loading,
    isAuthenticated: !!user,
    isAdmin: !!(user?.is_admin ?? (user?.role === 'ADMIN')),
    isBUCoordinator: user?.role === 'BU_COORDINATOR' || user?.role === 'RESPONSABLE',
    isResponsable: user?.role === 'BU_COORDINATOR' || user?.role === 'RESPONSABLE',
    isLogistiqueCoordinator: user?.role === 'LOGISTIQUE_COORDINATOR',
    isManager: user?.role === 'MANAGER',
    isComptable: user?.role === 'COMPTABLE',
    isEtudiant: user?.role === 'ETUDIANT',
    isFournisseur: user?.role === 'FOURNISSEUR',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
